<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M0.292894 7.29291C-0.0976308 7.68343 -0.0976307 8.3166 0.292894 8.70712L7.29289 15.7071L8.70711 14.2929L3.41421 9.00001L15 9.00001L15 7.00001L3.41421 7.00001L8.70711 1.70712L7.29289 0.292907L0.292894 7.29291Z"
          fill="#7B61FF"/>
</svg>
